import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  ContainerTitle,
  IconTitle,
  Title,
  QuestionIndex,
} from './styles';

import AddQuestions from './add-question';

const Ranking = (props) => {
  const {
    question,
    index,
    errors,
    touched,
    isEdit,
    taskIndex,
    testType,
  } = props;

  return (
    <Container>
      <ContainerTitle>
        <QuestionIndex>{index + 1}</QuestionIndex>
        <IconTitle src="/images/question-ranking.png" />
        <Title color="questionTitleRanking">
          Ranking
        </Title>
      </ContainerTitle>

      <AddQuestions
        question={question}
        index={index}
        errors={errors}
        touched={touched}
        isEdit={isEdit}
        taskIndex={taskIndex}
        testType={testType}
      />
    </Container>
  );
};

Ranking.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    questionOptions: PropTypes.array,
    randomize: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  isEdit: PropTypes.bool.isRequired,
  taskIndex: PropTypes.number,
  testType: PropTypes.string.isRequired,
};

Ranking.defaultProps = {
  taskIndex: null,
};

export default Ranking;
